module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "card "
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-6 input",
    class: {
      'has-danger': _vm.errors.has('nome')
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.user.firstName),
      expression: "body.user.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "nome"
    },
    domProps: {
      "value": (_vm.body.user.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.body.user.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('nome')),
      expression: "errors.has('nome')"
    }],
    staticClass: "form-control-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('nome')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 input",
    class: {
      'has-danger': _vm.errors.has('sobrenome')
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Sobrenome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.user.lastName),
      expression: "body.user.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "sobrenome"
    },
    domProps: {
      "value": (_vm.body.user.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.body.user.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('sobrenome')),
      expression: "errors.has('sobrenome')"
    }],
    staticClass: "form-control-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('sobrenome')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-6 input",
    class: {
      'has-danger': _vm.errors.has('login')
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Login")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.user.username),
      expression: "body.user.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "login"
    },
    domProps: {
      "value": (_vm.body.user.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.body.user.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('login')),
      expression: "errors.has('login')"
    }],
    staticClass: "form-control-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('login')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 input",
    class: {
      'has-danger': _vm.errors.has('email')
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.user.email),
      expression: "body.user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.body.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.body.user.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "form-control-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-6 input",
    class: {
      'has-danger': _vm.errors.has('senha')
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("\n                Senha\n                "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.body.user.id !== undefined),
      expression: "body.user.id !== undefined"
    }],
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.changePassword = !_vm.changePassword
      }
    }
  }, [_c('small', [_vm._v("(trocar)")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.changePassword ? 'required|confirmed:confirma senha' : ''),
      expression: "changePassword ? 'required|confirmed:confirma senha' : ''"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.body.user.password),
      expression: "body.user.password"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.changePassword),
      expression: "changePassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "senha"
    },
    domProps: {
      "value": (_vm.body.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.body.user.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('senha') && _vm.changePassword),
      expression: "errors.has('senha') && changePassword"
    }],
    staticClass: "form-control-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('senha')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changePassword),
      expression: "changePassword"
    }],
    staticClass: "form-group col-md-6 input",
    class: {
      'has-danger': _vm.errors.has('confirma senha')
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Confirma senha")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "confirma senha"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-6 select",
    class: {
      'has-danger': _vm.errors.has('method')
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Expiração")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.body.user.passwordExpiration),
      expression: "body.user.passwordExpiration",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "fila",
      "type": "number"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.body.user.passwordExpiration = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("30 Dias")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "45"
    }
  }, [_vm._v("45 Dias")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "60"
    }
  }, [_vm._v("60 dias")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Não expira")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Desativar")]), _vm._v(" "), _c('span', {
    staticClass: "form-control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.user.inactive),
      expression: "body.user.inactive"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.body.user.inactive) ? _vm._i(_vm.body.user.inactive, null) > -1 : (_vm.body.user.inactive)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.body.user.inactive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.body.user.inactive = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.body.user.inactive = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.body.user.inactive = $$c
        }
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label",
    attrs: {
      "for": "inputUrl"
    }
  }, [_vm._v("Meta")]), _vm._v(" "), _vm._l((_vm.body.user.meta), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('v-select', {
      staticClass: "metadata",
      attrs: {
        "taggable": "",
        "placeholder": "Chave",
        "options": _vm.metaKeys
      },
      model: {
        value: (item.key),
        callback: function($$v) {
          item.key = $$v
        },
        expression: "item.key"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("=")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.value),
        expression: "item.value"
      }],
      staticClass: "form-control col-md-3",
      attrs: {
        "type": "text",
        "placeholder": "Valor"
      },
      domProps: {
        "value": (item.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          item.value = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.removeMetaInfo(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "type": "button",
        "disabled": index !== (_vm.body.user.meta.length - 1)
      },
      on: {
        "click": function($event) {
          _vm.newMetaInfo()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    })])], 1)])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('h6', [_vm._v("Grupos")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.groups
    },
    model: {
      value: (_vm.selectedGroups),
      callback: function($$v) {
        _vm.selectedGroups = $$v
      },
      expression: "selectedGroups"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), (this.$route.params.id != undefined) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.generateAccessKey
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Gerar nova")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.accessKeys), function(ak) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(ak.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ak.secretKey))]), _vm._v(" "), _c('td', {
      staticClass: "actions"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.removeAccessKey(ak.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-sm",
    attrs: {
      "to": '/mystique/users'
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveUser
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar\n          ")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" "), _c('strong', [_vm._v("Usuário")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-10 text-left"
  }, [_c('i', {
    staticClass: "fa fa-key"
  }), _vm._v(" "), _c('b', [_vm._v("Chaves de acesso")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead"
  }, [_c('tr', [_c('th', [_vm._v("Id")]), _vm._v(" "), _c('th', [_vm._v("SecretKey")]), _vm._v(" "), _c('th')])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5ecd050a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ecd050a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mystique/users/Form.vue
// module id = 1569
// module chunks = 1